import actionTypes from '../actionTypes';

export function fetchData(fetch) {
  return async function (dispatch, getState) {
    try {
      const data = await fetch(getState);
      return dispatch({ type: actionTypes.DATA_FETCH_SUCCESS, data, isAsynchronous: true });
    } catch (error) {
      return dispatch({ type: actionTypes.DATA_FETCH_FAILURE, error, isAsynchronous: true });
    }
  };
}

export function updateData(data, bypassMiddleware) {
  return {
    type: actionTypes.DATA_UPDATE,
    data,
    bypassMiddleware,
  };
}

export function deleteData(dataToDelete) {
  return {
    type: actionTypes.DATA_DELETE,
    dataToDelete,
  };
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/dataActionsCreator.js